import React from "react";
import ActionButton from "./ActionButton";
import ImageUploader from "./ImageUploader";
import { FiPlus } from "react-icons/fi";

export default function CategoryForm({
  category,
  categoryIconUrl,
  setCategory,
  setCategoryIconUrl,
  addCategory,
}) {
  return (
    <div>
      <input
        placeholder="Նոր բաժին"
        value={category}
        onChange={(e) => setCategory(e.target.value)}
      />
      <ImageUploader
        value={categoryIconUrl}
        onChange={setCategoryIconUrl}
        placeholder="Բաժնի icon նկարի URL"
      />
      <ActionButton onAction={addCategory}>
        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}><FiPlus /> Ավելացնել Բաժին</span>
      </ActionButton>
    </div>
  );
}
